<template>
  <FullscreenVideoContainer
    v-if="video"
    v-bind="{ video, poster: image, horizontalFocus, verticalFocus, autoplay: true }"
    @update:poster-loaded="emit('update:image-loaded', $event)"
  >
    <slot />
  </FullscreenVideoContainer>
  <FullscreenImageContainer
    v-else
    v-bind="{ image, horizontalFocus, verticalFocus }"
    @update:loaded="emit('update:image-loaded', $event)"
  >
    <slot />
  </FullscreenImageContainer>
</template>

<script setup>
let props = defineProps({
  video: String,
  image: String,
  horizontalFocus: String,
  verticalFocus: String,
})

let emit = defineEmits(['update:image-loaded'])
</script>

<style lang="scss" scoped></style>
